module.exports = __webpack_public_path__ + "static/img/sign-language-reservation_2x.c7ed2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/signLanguage/sign-language-reservation_2x.png
// module id = kfzx
// module chunks = 1